export default __webpack_public_path__ + "static/media/title_en_sp.97fce3cc.png";